export default __webpack_public_path__ + "static/media/banner2.af4d6b0e.png";